/**
 * @generated SignedSource<<a4d8507da21ea0a47a0798a0c489dde3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Sidepane_userFragment$data = {
  readonly isInternal: boolean;
  readonly isStaff: boolean;
  readonly " $fragmentType": "Sidepane_userFragment";
};
export type Sidepane_userFragment$key = {
  readonly " $data"?: Sidepane_userFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Sidepane_userFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Sidepane_userFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isStaff",
      "storageKey": null
    }
  ],
  "type": "UserType",
  "abstractKey": null
};

(node as any).hash = "273cde71f9f925a0890bb6eaab3084b7";

export default node;
